import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { SingleTopUpModule } from './single'

const initialState = {
  changeTopUp: {
    activationView: 'activation',
    deactivationView: 'deactivation'
  },
  voucherTopUp: {
    view: 'input',
    amount: 0
  }
}

const TopUpModule = {
  namespaced: true,
  modules: {
    single: SingleTopUpModule
  },
  state: initialState,
  actions: {
    async deactivateAutoTopUp ({ commit, state }, nextStep) {
      commit('clearMessages', {}, { root: true })

      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeAutoTopUp {
          deactivateAutoTopUp{
            activationPossible,
            active,
            topUp {
              amount,
              trigger,
              type
            }
          }
        }`
      }).then((response) => {
        state.changeTopUp.deactivationView = nextStep
        commit('Transaction/removeTransactionId', 'changeAutoTopUp', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async changeAutoTopUp ({ commit, state, getters }, { topUpData, nextStep }) {
      commit('clearMessages', {}, { root: true })

      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeAutoTopUp ($changeAutoTopUpInput: ChangeAutoTopUpInput!) {
          changeAutoTopUp (autoTopUp: $changeAutoTopUpInput){
            activationPossible,
            active,
            topUp {
              amount,
              trigger,
              type
            }
          }
        }`,
        variables: {
          changeAutoTopUpInput: {
            amount: topUpData.amount,
            trigger: topUpData.trigger,
            type: getters.selectType(topUpData.type)
          }
        }
      }).then((response) => {
        state.changeTopUp.activationView = nextStep
        commit('Transaction/removeTransactionId', 'changeAutoTopUp', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async sendVoucher ({ commit, state, rootGetters }, { voucher, nextStep }) {
      commit('clearMessages', {}, { root: true })

      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation voucher ($input: String!) {
          topUpVoucher (voucher: $input) {
            amount
          }
        }`,
        variables: {
          input: voucher
        }
      }).then((response) => {
        state.voucherTopUp.amount = response.data.topUpVoucher.amount
        state.voucherTopUp.view = nextStep
        commit('Transaction/removeTransactionId', 'voucher', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    returnToInput (state, step) {
      state.voucherTopUp.view = step
    },
    setActivationView (state, step) {
      state.changeTopUp.activationView = step
    },
    setDeactivationView (state, step) {
      state.changeTopUp.deactivationView = step
    }
  },
  getters: {
    selectType: (state) => (type) => {
      if (type === 'monthly') {
        return 'DAY_OF_MONTH'
      } else if (type === 'byLimit') {
        return 'ACCOUNT_BALANCE'
      } else { return null }
    },
    view (state) {
      return state.voucherTopUp.view
    },
    amount (state) {
      return state.voucherTopUp.amount
    },
    getActivationView (state) {
      return state.changeTopUp.activationView
    },
    getDeactivationView (state) {
      return state.changeTopUp.deactivationView
    }
  }
}

export {
  TopUpModule
}
